var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HijriDatePicker',{attrs:{"typeDate":_vm.selectedOption,"min":_vm.minDate,"max":_vm.maxDate,"outlined":"","label":_vm.$t('HijriDate')},model:{value:(_vm.selectedDate),callback:function ($$v) {_vm.selectedDate=$$v},expression:"selectedDate"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }